export const minutesFromMidnight = (timeFrom: string) => {
  const timeFromHour = Number(timeFrom.slice(0, 2));
  const timeFromMinutes = Number(timeFrom.slice(2, 4));
  return 60 * timeFromHour + timeFromMinutes;
};

export const formatStartTime = (startTime: string) => {
  return startTime.replace(':', '');
};
